import { apiFetch, setStoredToken } from './client';
import { setRealtimeAuth } from '../db/client';

export type Perfil = 'admin' | 'administracion' | 'ventas' | 'mantenimiento' | 'nova' | 'marketing' | 'visitante';
export type CountryCode = 'AR' | 'MX';

export type BackendProfile = {
  id: string;
  usuario_app: string;
  nombre: string | null;
  apellido: string | null;
  perfil: Perfil;
  pais: string | null;
  status: string;
  email: string | null;
  /** ISO country the user belongs to by default. Drives data scoping. */
  pais_codigo: CountryCode;
  /** Countries the user is allowed to switch into via the country selector. */
  paises_permitidos: CountryCode[];
};

export async function login(credentials: { usuarioApp: string; password: string }) {
  const res = await apiFetch<{ token: string; profile: BackendProfile }>('/api/auth/login', {
    method: 'POST',
    body: credentials,
    anonymous: true,
  });
  setStoredToken(res.token);
  // Push the JWT into the Realtime client so gallery subscriptions see
  // the connection as `authenticated` (RLS gate). Same token the API
  // uses — Express signs them with the Supabase JWT secret.
  setRealtimeAuth(res.token);
  return res.profile;
}

export async function fetchMe(): Promise<BackendProfile> {
  const res = await apiFetch<{ profile: BackendProfile }>('/api/auth/me');
  return res.profile;
}

export type MenuPermissionRow = {
  menu_key: string;
  perfil: Perfil;
  visible: boolean;
};

/**
 * Nav visibility matrix from Supabase `menu_permissions`. Same for every
 * authenticated user — the caller filters by their `perfil` client-side.
 * Cached by React Query (see `useMenuPermissions`).
 */
export async function fetchMenuPermissions(): Promise<MenuPermissionRow[]> {
  const res = await apiFetch<{ permissions: MenuPermissionRow[] }>('/api/auth/menu-permissions');
  return res.permissions;
}

export function logout() {
  setStoredToken(null);
  setRealtimeAuth(null);
}
